/*
 * patient-referral (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { patientReferrals } from "./patient-referral.schema"

export const REFERRAL_DIRECTIONS = ["incoming", "outgoing"] as const
export type ReferralDirection = (typeof REFERRAL_DIRECTIONS)[number]

/* Select */
export type PatientReferral = z.infer<typeof selectPatientReferralSchema>
export const selectPatientReferralSchema = createSelectSchema(patientReferrals)

/* Filters */
export type PatientReferralFilters = z.infer<typeof patientReferralFiltersSchema>
export const patientReferralFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	referralId: z.string().optional(),
	direction: z.enum(REFERRAL_DIRECTIONS).optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createPatientReferralSchema = createInsertSchema(patientReferrals, {
	patientId: z.string().uuid(),
	referralId: z.string().uuid(),
	direction: z.enum(REFERRAL_DIRECTIONS),
	referralDate: z.string().optional(),
	notes: z.string().optional(),
}).partial(globalCreateExclude)
export type CreatePatientReferral = z.infer<typeof createPatientReferralSchema>

/* Update */
export const updatePatientReferralSchema = createInsertSchema(patientReferrals)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdatePatientReferral = z.infer<typeof updatePatientReferralSchema>
